import Animation from 'animation'

/*
 * Cycles
 */
class CycleAnimation extends Animation {

  match () {
    return true
  }

  bindAndAnimate (container, node) {
    // TODO - This is a no-op for now. Everything is handled in the main
    // container. We'll add animations eventually
  }

}

export default CycleAnimation
